export default [
  {
    event: 'openTourModal',
    modalCustomElement: '<tour-modal></tour-modal>',
    tagName: 'tour-modal',
  },
  {
    event: 'openDocumentsTreeModal',
    modalCustomElement: '<documents-tree-modal></documents-tree-modal>',
    tagName: 'documents-tree-modal',
  },
  {
    event: 'workOrderCreate',
    modalCustomElement: '<work-order-create></work-order-create>',
    tagName: 'work-order-create',
  },
  {
    event: 'openAdministrationMenu',
    modalCustomElement: '<administration-menu></administration-menu>',
    tagName: 'administration-menu',
  },
  {
    event: 'openAdministrationMenuBase',
    modalCustomElement: '<administration-menu open-base="true"></administration-menu>',
    tagName: 'administration-menu',
  },
];
